import { useTranslation } from 'react-i18next'
import { ProfileForm } from '../../components/profile/ProfileForm'

/**
 * User profile page
 */
export function ProfilePage() {
  const { t } = useTranslation()

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl tracking-tight">{t('profile.title', 'Profile')}</h1>
        <p className="text-muted-foreground">
          {t('profile.description', 'Manage your personal information.')}
        </p>
      </div>

      <div className="rounded-lg border bg-card p-6">
        <ProfileForm />
      </div>
    </div>
  )
}
